import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { NotificationService } from '../notifications/services/notification.service';
import { NotificatioDismiss, NotificationType } from '../notifications/models/notification-models';

@Injectable({
  providedIn: 'root',
})
export class ErrorHandlerService {
  constructor(private notifications: NotificationService) {}

  HandleError(error: HttpErrorResponse) {
    if (error && error.status === 401) {
      return;
    }

    if (error && error.status === 400) {
      const errorText = this.getValidationErrorText(error);

      this.notifications.warning(errorText);

      return;
    }

    if (error && error.error && error.error.code) {
      if (error.error.code === 10) {
        this.ShowDBConcurrencyError();
      } else if (error.error.code > 900000 && error.error.code < 1000000) {
        this.showG4Error();
      } else {
        this.ShowGenericError();
      }
    } else {
      this.ShowGenericError();
    }
  }

  ShowGenericError(): void {
    this.notifications.error('Der opstod en uventet fejl.');
  }

  ShowDBConcurrencyError(): void {
    const notificationRef = this.notifications.notify(
      NotificationType.error,
      'Serviceaftalen er blevet opdateret. Tryk OK for at genindlæse siden.',
      'OK',
      0
    );
    notificationRef.afterDismissed().subscribe((result: NotificatioDismiss) => {
      if (result.dismissedByAction === true) {
        window.location.reload();
      }
    });
  }

  showG4Error() {
    this.notifications.notify(NotificationType.error, 'G4 service svarer ikke i øjeblikket. Prøv venligst senere', 'Forstået', 0);
  }

  getValidationErrorText(error: HttpErrorResponse): string {
    let validationErrors = [];
    if (error.error) {
      if (error.error.hasOwnProperty('errors')) {
        for (let key in error.error.errors) {
          validationErrors = validationErrors.concat(error.error.errors[key]);
        }
      } else {
        const errorObj = typeof error.error === 'object' ? error.error : JSON.parse(error.error);

        for (var errorKey in errorObj) {
          if (errorObj.hasOwnProperty(errorKey)) {
            validationErrors = validationErrors.concat(errorObj[errorKey]);
          }
        }
      }
    }

    return validationErrors.join('\r\n');
  }
}
